import angular from 'angular'
import './product_lines.service'

angular
  .module('admin.product_lines', ['admin.product_lines.service'])
  .controller('ProductLinesAdminCtrl', ProductLinesAdminCtrl)

/** @ngInject */
function ProductLinesAdminCtrl(
  $scope,
  $timeout,
  $state,
  $stateParams,
  ProductLinesService,
  UploadService,
) {
  var vm = this
  vm.items = []
  vm.pathImg = ''
  vm.create = false
  vm.model = {}

  function reloadPagination() {
    vm.totalUsers = 0
    vm.usersPerPage = 25
    vm.oldPage = 0
    vm.currentPage = 25
    vm.first = true
    vm.totalItems = 0
    vm.pagination = {
      current: 1,
    }
  }

  vm.sortType = 'n-asc'
  vm.sortReverse = false

  reloadPagination()
  load(1)

  var oldSortType
  function load(pageNumber) {
    if (pageNumber === 1) {
      vm.pagination.current = 1
    }
    if (!vm.first) {
      vm.currentPage = pageNumber * 25
      vm.oldPage = vm.currentPage - 25
    } else {
      vm.first = false
    }

    oldSortType = angular.copy(vm.sortType)
    ProductLinesService.list(vm.oldPage, 25, vm.sortType).then(function(result) {
      var products = result.results
      if (vm.totalItems === 0) {
        vm.totalItems = result.ct
      }
      for (var i = 0; i < products.length; i++) {
        products[i].editing = false
        products[i].loadT = false
      }

      vm.sortType = oldSortType
      vm.items = products
      vm.disableTable = false
    })
  }

  vm.pageChanged = function(newPage) {
    vm.sortType = oldSortType
    load(newPage)
  }

  vm.add = function() {
    vm.create = true
    vm.items.unshift({
      id: 0,
      t: '',
      img: '',
      editing: true,
    })
  }

  vm.edit = function(item) {
    item.editing = !item.editing
  }

  vm.save = function(item) {
    if (
      item.t === null ||
      item.t === undefined ||
      item.t === '' ||
      item.img === null ||
      item.img === undefined ||
      item.img === ''
    ) {
      swal('All fields is required.', '', 'warning')
      return
    }

    vm.create = false

    if (item.id !== undefined && item.id !== '' && item.id !== 0) {
      ProductLinesService.update(item.id, item).then(function() {
        reloadPagination()
        vm.sortType = oldSortType
        load(vm.pagination.current)
      })
    } else {
      delete item.id
      delete item.editing
      ProductLinesService.save(item).then(function() {
        reloadPagination()
        vm.sortType = oldSortType
        load(vm.pagination.current)
      })
    }
  }

  vm.cancel = function(item) {
    swal(
      {
        title: 'Are you sure ?',
        text: 'Product line will not be saved',
        type: 'warning',
        showCancelButton: true,
        closeOnConfirm: true,
        animation: 'slide-from-top',
      },
      function(isConfirm) {
        if (isConfirm) {
          if (item.id === 0) {
            vm.items.remove(item)
          }
          item.editing = !item.editing
          vm.create = false
          $scope.$apply()
        }
      },
    )
  }

  vm.delete = function(item) {
    swal(
      {
        title: 'Are you sure ?',
        text: 'You want delete this product line',
        type: 'warning',
        showCancelButton: true,
        closeOnConfirm: true,
        animation: 'slide-from-top',
      },
      function(isConfirm) {
        if (isConfirm) {
          ProductLinesService.remove(item.id).then(
            function() {
              if (vm.items.length === 1 || vm.items.length === 25) {
                $state.reload()
              } else {
                reloadPagination()
                vm.sortType = oldSortType
                load(vm.pagination.current)
              }
            },
            function() {
              $timeout(function() {
                swal(
                  "You can't delete this Product Line. It is being used by other items",
                  '',
                  'error',
                )
              }, 800)
            },
          )
        }
      },
    )
  }

  vm.back = function() {
    if (vm.create) {
      swal(
        {
          title: 'Are you sure ?',
          text: 'Product line will not be saved',
          type: 'warning',
          showCancelButton: true,
          closeOnConfirm: true,
          animation: 'slide-from-top',
        },
        function(isConfirm) {
          if (isConfirm) {
            $state.go('admin.home')
          } else {
            vm.items.map(function(item) {
              if (item.id === 0) {
                item.editing = !item.editing
                vm.items.remove(item)
                vm.create = false
              }
            })
            $scope.$apply()
          }
        },
      )
    } else {
      $state.go('admin.home')
    }
  }

  vm.update = function(model) {
    ProductLinesService.update(model.id, { n: model.o }).then(function() {
      vm.sortType = oldSortType
      load(vm.pagination.current)
    })
  }

  vm.disableTable = false
  vm.barConfig = {
    animation: 350,
    // ghostClass: "ghost",
    onEnd: function(/** ngSortEvent */ evt) {
      vm.disableTable = true
      vm.orderList(evt)
    },
  }

  vm.orderList = function(evt) {
    for (var i = 0; i < vm.items.length; i++) {
      vm.items[i].o = parseInt(evt.newIndex) + 1
      if (vm.items[i].id === evt.model.id) {
        vm.update(evt.model)
      }
    }
  }

  vm.upload = function(item) {
    item.loadT = true
    UploadService.save('product_lines', vm.pathImg, 'img', item.id).then(function(fileName) {
      item.loadT = false
      item.img = fileName
      if (!item.editing) {
        ProductLinesService.update(item.id, { img: item.img }).then(function() {})
      }
    })
  }

  vm.sort = function(type) {
    vm.sortReverse = !vm.sortReverse
    if (vm.sortReverse) {
      vm.sortType = type + '-asc'
    } else {
      vm.sortType = type + '-desc'
    }
    load()
  }
}
